import { HTTP_ORDERDT_FETCHING, HTTP_ORDERDT_SUCCESS, HTTP_ORDERDT_FAILED } from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_ORDERDT_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_ORDERDT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_ORDERDT_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
